import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

class ResendVerification extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
ResendVerification.modelName = 'ResendVerification'
const servicePath = 'resend-verification'
const servicePlugin = makeServicePlugin({
  Model: ResendVerification,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
